import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.v4r_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.s4r_1;
    if (index >= interceptors.q2()) {
      $this.w4r();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.v4r_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.u4r_1, $completion);
  }
   while (true);
  return $this.u4r_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.s4r_1 = interceptors;
        this.t4r_1 = coroutineContext;
        this.u4r_1 = subject;
        this.v4r_1 = 0;
      }
      bw() {
        return this.t4r_1;
      }
      x4r() {
        return this.u4r_1;
      }
      w4r() {
        this.v4r_1 = -1;
      }
      *y4r(subject, $completion) {
        this.u4r_1 = subject;
        return yield* this.z4r($completion);
      }
      *z4r($completion) {
        var index = this.v4r_1;
        if (index < 0)
          return this.u4r_1;
        if (index >= this.s4r_1.q2()) {
          this.w4r();
          return this.u4r_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *a4s(initial, $completion) {
        this.v4r_1 = 0;
        this.u4r_1 = initial;
        return yield* this.z4r($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
